'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["favorites", "fetchFavoriteColors"];
import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withFavoriteColors = WrappedComponent => {
  function WithFavoriteColors(props) {
    const {
        favorites,
        fetchFavoriteColors
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    const [favoriteColors, setFavoriteColors] = useState(favorites);
    const getFavoriteColors = useCallback(() => {
      fetchFavoriteColors().then(results => {
        setFavoriteColors(results);
      }).catch(error => {
        console.error(error);
        setFavoriteColors([]);
      });
    }, [fetchFavoriteColors]);
    useEffect(() => {
      // Fetch favorite colors if [favorites] is absent or nothing was cached
      if (!favoriteColors) {
        getFavoriteColors();
      }
    }, [favoriteColors, getFavoriteColors]);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest, {
      favorites: favoriteColors || []
    }));
  }
  WithFavoriteColors.propTypes = {
    fetchFavoriteColors: PropTypes.func.isRequired,
    favorites: PropTypes.arrayOf(PropTypes.string)
  };
  WithFavoriteColors.displayName = `WithFavoriteColors(${getComponentName(WrappedComponent)})`;
  return WithFavoriteColors;
};
export default withFavoriteColors;